import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  NgZone,
  AfterViewInit,
  ViewChild,
  HostListener,
  OnDestroy,
} from '@angular/core';
import {
  CarouselComponent,
  OwlOptions,
  SlidesOutputData,
} from 'ngx-owl-carousel-o';
import { StoreDataServiceService } from './store-data-service.service';
import { ActivatedRoute } from '@angular/router';
import { AngularFireRemoteConfig } from '@angular/fire/compat/remote-config';
import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';
import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util.service';
import {
  RemoteConfig,
  fetchAndActivate,
  getValue,
} from 'firebase/remote-config';
import { ConstantService } from './service/constant.service';
import { EncryptionService } from './service/encryption.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  // Grab the native DOM wrapper to query child buttons securely
  @ViewChild('carouselContainer', { read: ElementRef }) container!: ElementRef;
  // Grab the component class API instance to handle keyboard navigation controls
  @ViewChild('carouselRef') carouselComponent!: CarouselComponent;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: false, // Disable built-in autoplay, we manage it manually
    autoplayTimeout: 4000,
    autoplayHoverPause: false, // Disable since we manage manually
    navText: ['<', '>'],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      760: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
    nav: true,
  };
  isCarouselPlaying: boolean = true;

  slides = [
    {
      id: 0,
      content:
        'Powerful platform for lightning fast trading and easy trade execution.',
      // announcement:
      //   'Slide 1 of 3: Powerful platform for lightning fast trading and easy trade execution',
      isActive: true,
    },
    {
      id: 1,
      content:
        'Intuitive design and single page view for complete details of a company.',
      // announcement:
      //   'Slide 2 of 3: Intuitive design and single page view for complete details of a company',
      isActive: false,
    },
    {
      id: 2,
      content:
        'Advanced charts and custom watchlist for informed investing decisions.',
      // announcement:
      //   'Slide 3 of 3: Advanced charts and custom watchlist for informed investing decisions',
      isActive: false,
    },
  ];

  IpAddress = '';
  themes: string = '';
  returnUrl: string = '';
  isChecked: boolean = true;
  title = '5P_Insta_Rewards';
  showLoader = false;
  patterns = [
    '/SignOn/Auth',
    // '/Home/ClientCookieAuth',
    '/vlogin-page',
    '/login-customersupport',
    '/error',
    '/lwp',
    '/dealer',
  ];
  myCurrentURL: string = '';
  patternRedirectionURL: string = '';
  domainUrl: string;
  hostOrigin: string;
  pathname: string;
  queryParams: string;

  //public IpAddress : any;
  constructor(
    private storeDataServiceService: StoreDataServiceService,
    private renderer: Renderer2,
    private el: ElementRef,
    private activatedRouter: ActivatedRoute,
    private remoteConfig: AngularFireRemoteConfig,
    public constantService: ConstantService,
    private utilService: UtilService,
    private encryptionService: EncryptionService,
    private zone: NgZone,
    private toastr: ToastrService,
    private cookieService: CookieService
  ) {
    this.determineTheme();
  }

  applyTheme(theme: string) {
    if (theme === 'dark') {
      this.renderer.addClass(document.body, 'dark-mode');
    } else {
      this.renderer.removeClass(document.body, 'dark-mode');
    }
  }
  // determines the theme
  determineTheme() {
    if (this.cookieService.check('theme')) {
      this.themes = this.cookieService.get('theme');
    } else {
      let storedTheme = this.storeDataServiceService.getUser_Themes();
      if (storedTheme !== undefined) {
        this.themes = storedTheme;
      } else {
        this.themes = this.detectSystemTheme(); // Default to system theme
      }
    }
    this.isChecked = this.themes === 'dark';
    this.storeDataServiceService.setUser_Themes(this.themes);
    this.applyTheme(this.themes); // Apply the theme without toggling
  }

  toggleDarkMode() {
    this.themes = this.themes === 'dark' ? 'light' : 'dark'; // Toggle the theme
    this.storeDataServiceService.setUser_Themes(this.themes);
    this.applyTheme(this.themes); // Apply the updated theme
    this.isChecked = this.themes === 'dark';
  }
  // detects the system theme if no theme is set
  detectSystemTheme(): string {
    try {
      let value = window.matchMedia?.('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
      return value;
    } catch (e) {
      return 'light';
    }
  }

  async ngOnInit(): Promise<void> {
    this.showLoader = true;
    this.initializeFireBaseAppAndRemoteConfig()
      .then(() => {})
      .finally(() => {});
    this.storeDataServiceService
      .fetchData()
      .then((result) => {
        this.IpAddress = result;
        this.storeDataServiceService.setIpAddress(this.IpAddress);
      })
      .finally(() => {
        this.showLoader = false;
      })
      .catch((error) => {
        this.showLoader = false;
        console.log('error', error);
      });
  }

  /**
   * Fires every time the carousel initializes or shifts to a new slide.
   * Replaces jQuery's afterInit and afterAction.
   */
  updateAccessibility(event: SlidesOutputData) {
    const startPosition = event.startPosition || 0;

    // Update active state on slide objects
    this.slides.forEach((slide, index) => {
      slide.isActive = index === startPosition;
    });

    // Configure navigation buttons (still need imperative approach for owl-generated elements)
    setTimeout(() => {
      const hostEl = this.container.nativeElement as HTMLElement;

      // Hide cloned slides (owl carousel clones for infinite loop)
      const clonedSlides = hostEl.querySelectorAll('.owl-item.cloned');
      clonedSlides.forEach((slide) => {
        slide.setAttribute('aria-hidden', 'true');
      });

      // Configure Next/Prev Buttons
      const prevButton = hostEl.querySelector('.owl-prev');
      const nextButton = hostEl.querySelector('.owl-next');

      if (prevButton && nextButton) {
        prevButton.setAttribute('role', 'button');
        prevButton.setAttribute('aria-label', 'Previous slide');
        prevButton.setAttribute('title', 'Previous slide');
        prevButton.setAttribute('tabindex', '0');

        nextButton.setAttribute('role', 'button');
        nextButton.setAttribute('aria-label', 'Next slide');
        nextButton.setAttribute('title', 'Next slide');
        nextButton.setAttribute('tabindex', '0');
      }
    }, 100);
  }

  /**
   * Replaces jQuery $(document).on('keydown').
   * Angular hosts event listeners safely to prevent memory leaks when components destroy.
   */
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    const activeElement = document.activeElement;
    const hostEl = this.container.nativeElement;

    // Check if the focus is inside our specific carousel wrapper container
    if (!hostEl.contains(activeElement)) {
      return;
    }

    // Logic for Arrow keys when the entire container wrapper has focus
    if (activeElement === hostEl) {
      if (event.key === 'ArrowRight') {
        this.carouselComponent.next();
      } else if (event.key === 'ArrowLeft') {
        this.carouselComponent.prev();
      }
    }

    // Logic for pressing "Enter" on individual custom focused control buttons
    if (event.key === 'Enter') {
      if (activeElement?.classList.contains('owl-next')) {
        this.carouselComponent.next();
      } else if (activeElement?.classList.contains('owl-prev')) {
        this.carouselComponent.prev();
      }
    }
  }

  // toggles the theme of login page

  isChangedtheme(): void {
    this.storeDataServiceService.defafulThemeChange('Y');
    this.toggleDarkMode();
  }

  initializeFireBaseAppAndRemoteConfig = async () => {
    try {
      const app = initializeApp(environment.firebase);
      const remoteConfig: RemoteConfig = getRemoteConfig(app);
      remoteConfig.settings.minimumFetchIntervalMillis = 60000;

      await fetchAndActivate(remoteConfig);
      const frontend_crossSell_keys = getValue(
        remoteConfig,
        'frontend_crossSell_keys'
      ).asString();
      const web_tradestation_url = getValue(
        remoteConfig,
        'web_tradestation_url'
      ).asString();
      let remoteConfigData, webremoteConfigData;
      try {
        remoteConfigData = JSON.parse(frontend_crossSell_keys);
        webremoteConfigData = JSON.parse(web_tradestation_url);
        this.storeDataServiceService.setFirebasePopupConfigration(
          remoteConfigData.isPopupEnabled
        ); // this value in global service
        this.storeDataServiceService.setDelayApiResponseTimer(
          remoteConfigData.APIDelayValue
        ); // this value in global service
        this.storeDataServiceService.setApiTimeoutFirebaseConfigration(
          remoteConfigData.APITimeoutValue
        );
        this.myCurrentURL = remoteConfigData.myCurrentURL.toLowerCase();
        this.patternRedirectionURL =
          remoteConfigData.patternRedirectionURL.toLowerCase();
        this.storeDataServiceService.setCaptchaEnabled(
          remoteConfigData.isCaptchaEnabled
        ); //isCaptchaEnabledPreProd
        this.storeDataServiceService.setNeedtoCallTradestationBetaApi(
          remoteConfigData.tradestationRedirectionThroughAPI
        ); // 'Y'
        this.storeDataServiceService.setTradestationRedirectionValue(
          remoteConfigData.tradestationRedirectionValue
        ); // 'OT & NT'
        this.storeDataServiceService.setdefaultTradestationUrl(
          webremoteConfigData.url
        );
        this.storeDataServiceService.setdefaultNewTradestationUrl(
          webremoteConfigData.newUrl
        );
        this.storeDataServiceService.setSwarajauthSecretKey(
          remoteConfigData.swarajauthProductionSecretKey
        );
        this.storeDataServiceService.setAllowDomainList(
          remoteConfigData.allowDormantUserForDomain
        );
        this.storeDataServiceService.setAspxAuthAPI(
          remoteConfigData.isToCallAspxauthAPI
        );
      } catch (error) {
        console.error('Error parsing remote config data', error);
        this.setDefaultConfig();
      }
    } catch (err) {
      console.error('Error initializing Firebase', err);
      this.setDefaultConfig();
    } finally {
    }
  };

  setDefaultConfig() {
    this.storeDataServiceService.setFirebasePopupConfigration(true); // if error then set default value true
    this.myCurrentURL = 'https://login.5paisa.com';
    this.patternRedirectionURL = 'https://login.5paisa.com';
    this.storeDataServiceService.setCaptchaEnabled('N'); // if error then set default value false
  }

  showSuccess() {
    this.toastr.error('Hello world!', 'Toastr fun!', {
      timeOut: 3000,
      closeButton: true,
      progressBar: true,
    });
  }
}
